module.exports = __webpack_public_path__ + "img/Describe.b8df7365.svg";